import React, { Component } from "react";
import EarMonkeysGame from "../components/earmonkeys/EarMonkeysGame";

class EarMonkeys extends Component {
  render() {
    return (
      <div>
        <EarMonkeysGame />
      </div>
    );
  }
}

export default EarMonkeys;
